export default "__VITE_ASSET__3e0d4aae__"